import { SecurityAccessFeaturesEnum } from 'bff';
import { useUserContext } from 'providers/managers/user-context-manager/user-context-manager';

export const useUserHasFeature = (
  feature: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[],
  exhaustive = false
) => {
  const { canAccessAny, canAccessAll } = useUserContext();

  return exhaustive ? canAccessAll(feature) : canAccessAny(feature);
};
